import SuperJSON from "superjson";
import Id from "../types/Id";

export default class CustomerUid extends Id<"customerUid"> {}

SuperJSON.registerClass(CustomerUid, { identifier: "CustomerUid" });
